
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.12596',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.12596",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.479",
  "data-fetching-client": "static-1.9750",
  "foundations-components": "static-1.8101",
  "foundations-components-legacy": "static-1.1126",
  "foundations-theming": "static-1.4520",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.83",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8105",
  "hub-http-shared-msw-handlers": "static-1.10177",
  "hubspot-dlb": "static-2.1854",
  "hubspot-url-utils": "static-1.4132",
  "HubStyleTokens": "static-2.11562",
  "I18n": "static-7.1634",
  "jasmine-runner": "static-1.6549",
  "marketplace-storefront-base": "static-1.12659",
  "quartz": "static-1.7137",
  "react-dlb": "static-1.80",
  "react-rhumb": "static-1.16770",
  "reactive-variable-buffer-atom": "static-1.2945",
  "reporting-testing-lib": "static-1.9832",
  "settings-ui-lib": "static-1.12607",
  "SharedI18nStrings": "static-1.182",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7296",
  "ui-addon-i18n": "static-1.11239",
  "ui-addon-react-router-dom": "static-1.9628",
  "unified-auth": "static-1.594",
  "unified-auth-core-lib": "static-1.876",
  "usage-tracker": "static-1.7436",
  "usage-tracker-core": "static-1.7286",
  "customer-data-property-utils": "static-1.8182",
  "hub-http": "static-1.6309",
  "integrations-lib": "static-1.16444",
  "marketplace-ui-common": "static-1.20069",
  "property-management-iframe": "static-1.13458",
  "quartz-config": "static-1.915",
  "quartz-core": "static-1.6356",
  "quartz-routing": "static-1.567",
  "quick-fetch": "static-1.3983",
  "react": "static-7.187",
  "rpc-client-utils": "static-1.4743",
  "ts-schema": "static-1.4146",
  "ui-universal-auth": "static-1.9080",
  "UIComponents": "static-3.8508",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.79",
  "metrics-js": "static-1.9637",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3466",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3414",
  "quartz-webpack": "static-1.3361",
  "bend-plugin-quartz-routing": "static-1.215",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4370",
  "floating-ui": "static-1.57",
  "foundations-assets": "static-1.4957",
  "foundations-theming-specialty": "static-1.2236",
  "framer-motion": "static-1.73",
  "hs-story-utils": "static-1.9510",
  "react-aria": "static-1.67",
  "react-create-root-preference": "static-1.32",
  "react-select-plus": "static-1.106",
  "react-utils": "static-2.5409",
  "react-virtualized": "static-2.100",
  "StyleGuideUI": "static-3.488",
  "tanstack-table": "static-1.56",
  "trellis-assets": "static-1.2154",
  "ui-fonts": "static-1.824",
  "ui-images": "static-2.1174",
  "bend-plugin-foundations-theming": "static-1.3003",
  "foundations-theming-base": "static-1.3505",
  "stylex": "static-1.34",
  "HeadJS": "static-2.766",
  "hs-test-utils-bend-plugin": "static-1.3216",
  "msw": "static-1.39",
  "testing-library": "static-1.153",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.222",
  "moment-timezone": "static-5.84",
  "jasmine": "static-4.4413",
  "ai-components-ui-library": "static-1.9173",
  "ai-rendering-library": "static-1.10482",
  "chirp-fetch": "static-1.1975",
  "connections-embed-lib": "static-1.1146",
  "copilot-toolkit": "static-1.11358",
  "feedback-loader": "static-1.29455",
  "laboratory-lib": "static-3.7243",
  "marketplace-embed": "static-1.22366",
  "marketplace-ui-details": "static-1.9964",
  "marketplace-ui-reviews": "static-1.20024",
  "marketplace-ui-tracking": "static-1.14239",
  "sanitize-text": "static-1.8232",
  "ui-addon-video-player": "static-1.8791",
  "usage-tracker-multi": "static-1.5850",
  "usage-tracker-session-replay": "static-1.5122",
  "wootric-nps": "static-1.7048",
  "quartz-head": "static-1.802",
  "web-vitals": "static-1.7",
  "apollo-link-hub-http": "static-2.4740",
  "immer": "static-1.33",
  "immerable": "static-1.4242",
  "highcharts": "static-8.105",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2557",
  "reporting-data": "static-1.67899",
  "cssUtils": "static-1.816",
  "flux-actions": "static-1.343",
  "HubStyle": "static-2.11869",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10296",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10451",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7426",
  "icons": "static-2.651",
  "marketplace-ui-apps-core": "static-1.18601",
  "storybook-react": "static-1.34",
  "trellis-story-utils": "static-1.4600",
  "foundations-components-test-utils": "static-1.5584",
  "quartz-i18n": "static-1.812",
  "react-input-autosize": "static-2.17",
  "ads-unified-auth-lib": "static-1.249",
  "google-sheets-integration-lib": "static-1.498",
  "microsoft-drive-integration-lib": "static-1.636",
  "slack-ui-library": "static-1.10480",
  "fsm": "static-1.3817",
  "customer-data-objects": "static-1.7765",
  "property-translator": "static-1.5483",
  "hs-locale-management": "static-1.147",
  "frontend-preferences-client": "static-1.8014",
  "hs-promise-utils": "static-1.5679",
  "hubspot-apollo-client": "static-1.4965",
  "integrations-error-boundary-lib": "static-1.13859",
  "integrations-tracking-lib": "static-1.5694",
  "native-integrations-shared-strings": "static-1.7869",
  "reselect": "static-2.16",
  "sanitize": "static-1.4564",
  "superstore": "static-1.4848",
  "ui-shepherd-react": "static-3.10309",
  "ai-settings-ui-library": "static-1.8024",
  "hub-http-janus": "static-1.841",
  "hubspotter-http": "static-1.4717",
  "immutable-less": "static-1.4741",
  "marketplace-ui-client-types": "static-1.17476",
  "nav-meta": "static-1.29876",
  "react-window": "static-1.13",
  "self-service-api": "static-1.10335",
  "ui-addon-upgrades": "static-9.18112",
  "inbound-db-properties-service-client": "static-1.3911",
  "property-management-common": "static-1.5746",
  "ui-addon-iframeable": "static-1.9150",
  "dispatcher": "static-1.138",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.540",
  "module-federation": "static-1.24",
  "quartz-auth": "static-1.812",
  "quartz-test": "static-1.812",
  "quartz-tracking": "static-1.516",
  "trellis-components": "static-1.2173",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.153",
  "bender-build-tools": "static-1.3278",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.21715",
  "ContentUtils": "static-1.68606",
  "customer-data-objects-ui-components": "static-1.13119",
  "sassPrefix": "static-1.157",
  "breeze-engine-core": "static-1.281",
  "breeze-onboarding-components": "static-1.178",
  "avatar-components": "static-1.2585",
  "customer-data-filters-ui": "static-1.40094",
  "customer-data-reference-ui-components": "static-1.13257",
  "embedded-academy-lib": "static-1.14595",
  "ExportDialog": "static-6.10470",
  "highlight.js": "static-1.80",
  "markdown-it": "static-1.6",
  "mermaid": "static-1.3",
  "reporting-action-components": "static-1.41519",
  "reporting-snowflake": "static-1.56517",
  "reporting-ui-components": "static-2.65170",
  "reporting-visualizations": "static-1.59975",
  "ui-addon-teams": "static-1.21666",
  "integrations-reconnect-lib": "static-1.119",
  "magpie-lib": "static-1.5610",
  "navigation-components": "static-1.18239",
  "breeze-engine-lib": "static-1.1003",
  "magpie-types": "static-1.5070",
  "simple-logging-lib": "static-1.3138",
  "ai-studio-lib": "static-1.11870",
  "app-governance-lib": "static-1.1830",
  "developer-experience-shared-components": "static-1.10601",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.8092",
  "ui-product-approvals": "static-1.28514",
  "ui-tool-access": "static-1.10236",
  "usage-based-billing-components-lib": "static-1.9331",
  "usage-tracker-anonymous": "static-1.5853",
  "usage-tracker-public": "static-1.7247",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3652",
  "persist-promise": "static-1.3787",
  "reference-resolvers": "static-1.8262",
  "ui-extensibility-client-types": "static-1.4012",
  "hubspot-apollo-cache": "static-1.424",
  "universal-page-editor-lib": "static-1.3105",
  "final-form": "static-1.71",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.3028",
  "merchandise-lib": "static-1.265",
  "atom": "static-1.5162",
  "purchase-motions-components": "static-1.6053",
  "salesImages": "static-1.526",
  "batch-promise": "static-1.1630",
  "crm-component-utils": "static-1.39317",
  "crm-properties-common-lib": "static-1.5976",
  "customer-data-properties": "static-1.51883",
  "framework-data-schema-resolvers": "static-1.6977",
  "property-value-citations": "static-1.2497",
  "reference-resolvers-lite": "static-1.8186",
  "ui-business-units-lib": "static-1.9148",
  "navigation-messaging": "static-1.7566",
  "hubspotter-http-shared-msw-handlers": "static-1.10175",
  "base-ui": "static-1.12",
  "react-day-picker": "static-1.4",
  "trellis-theming": "static-1.1027",
  "tanstack-virtual": "static-1.31",
  "cms-field-types": "static-1.4900",
  "content-icons-ui": "static-1.2250",
  "customer-data-ui-utilities": "static-1.9913",
  "conversations-skeleton-state": "static-1.7337",
  "crm-message-bus": "static-1.43210",
  "customer-data-filters-ui-msw-helpers": "static-1.22529",
  "events-data-lib": "static-1.318",
  "FormUrlGenerator": "static-2.4809",
  "framework-builder-read-service-client": "static-1.4071",
  "framework-data-schema-quick-fetch": "static-1.6882",
  "multi-account-reference-resolvers": "static-1.1070",
  "onboarding-tours": "static-1.16762",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.13929",
  "academy-common-lib": "static-1.14055",
  "content-assistance-lib": "static-1.7889",
  "dashboard-lib": "static-1.81872",
  "file-manager-components": "static-1.23841",
  "getting-started-shared-tasks": "static-1.18657",
  "hubspot-prosemirror": "static-1.18473",
  "hubspot-prosemirror-plugins": "static-1.18465",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.19975",
  "share-with-third-party-component-lib": "static-1.8792",
  "ui-addon-draggable": "static-3.4850",
  "ui-asset-management-lib": "static-1.11147",
  "user-context": "static-1.5197",
  "growth-payments-core": "static-1.25638",
  "reporting-plugins": "static-1.10472",
  "reporting-reports": "static-1.67577",
  "idb-keyval": "static-1.45",
  "reactive-lib": "static-1.813",
  "nest": "static-1.319",
  "ably": "static-2.2",
  "codemirror": "static-5.96",
  "react-codemirror": "static-1.10715",
  "framework-listing-lib": "static-2.28940",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.30925",
  "apps-service-types": "static-1.3910",
  "oauth-service-types": "static-1.4339",
  "react-dnd-compat": "static-1.4702",
  "ui-product-approvals-common": "static-1.409",
  "onboarding-scopes": "static-1.6549",
  "onboarding-tours-client": "static-1.4976",
  "platform-infra-nav-components": "static-1.7739",
  "subscription-experience-data-types": "static-1.15043",
  "crm-record-cards-service-types": "static-1.3656",
  "location-customization-utils-lib": "static-1.9517",
  "redux-thunk": "static-2.43",
  "purchase-motions-api": "static-1.6056",
  "signup-constants": "static-1.19044",
  "signup-ui-url-generator": "static-2.8143",
  "card-properties-lib": "static-1.44459",
  "commerce-subscription-lib": "static-1.37379",
  "crm-actions": "static-1.6427",
  "crm-cards-sdk": "static-1.43841",
  "customer-data-properties-shared-msw-handlers": "static-1.9504",
  "customer-data-tracking": "static-1.6977",
  "hs-resources": "static-1.262",
  "pulse": "static-1.683",
  "calling-global-api": "static-1.64815",
  "calling-internal-common": "static-1.31395",
  "calling-lifecycle-internal": "static-1.66197",
  "calling-lifecycle-messages": "static-1.58491",
  "commerce-products-lib": "static-1.9865",
  "conditional-properties-service-client": "static-1.3863",
  "crm-links": "static-1.6394",
  "crm-pipelines-api-client-types": "static-1.4204",
  "external-options-client-types": "static-1.4199",
  "google-libphonenumber": "static-1.39",
  "inbounddb-objects-service-types": "static-1.4287",
  "meetings-icalendar-utils-lib": "static-1.721",
  "multi-currency-client-types": "static-1.3757",
  "object-builder-ui-client": "static-1.49051",
  "pipeline-validation-client-types": "static-1.4032",
  "smart-property-lib": "static-1.7624",
  "tiered-pricing": "static-1.1408",
  "zustand": "static-1.74",
  "ui-addon-form-validation": "static-1.11077",
  "fdsr-migration-layer": "static-1.96",
  "react-immutable-render-mixin": "static-1.9",
  "restore-request-side-panel-lib": "static-1.1096",
  "growth-data-modal": "static-1.5566",
  "growth-onboarding-confetti": "static-1.3154",
  "growth-onboarding-next-action-utils": "static-1.2178",
  "onboarding-tours-utils": "static-1.828",
  "ui-shepherd-tracker": "static-1.7690",
  "academy-service-client": "static-1.3771",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.39340",
  "FileManagerLib": "static-1.39481",
  "video-embed": "static-1.36056",
  "ui-coaching-tips": "static-1.28807",
  "redux-actions": "static-3.7",
  "video-components-external": "static-1.11564",
  "video-data-lib": "static-1.35222",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8552",
  "payment-link-components": "static-1.23746",
  "ui-addon-emoji-picker": "static-1.9975",
  "EmailSignatureEditor": "static-1.24562",
  "viral-links-lib": "static-1.7156",
  "data-token-picker": "static-1.16556",
  "react-flip-move": "static-1.72",
  "nested-table": "static-1.313",
  "timezone-utils": "static-2.5331",
  "seat-types-lib": "static-1.219",
  "getting-started-shared-tasks-store": "static-1.17775",
  "ui-addon-opt": "static-4.8448",
  "campaign-roi-lib": "static-1.9348",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "customer-data-views-management": "static-1.25623",
  "framework-data-table": "static-2.12109",
  "marketing-platform-lib": "static-1.6951",
  "nudge-client-utils": "static-1.2761",
  "nudge-custom-ui-functions": "static-1.1184",
  "switchboard-lib": "static-1.310",
  "app-users-service-client": "static-1.5694",
  "app-users-service-types": "static-1.5102",
  "mini-checkout-client": "static-1.27000",
  "onboarding-utils": "static-1.5448",
  "permissions-shared-i18n-strings-fe": "static-1.2058",
  "ui-coaching-tips-shared-config": "static-1.28792",
  "edison-service-client-types": "static-1.477",
  "crm_data": "static-4.92250",
  "customer-data-sidebar": "static-2.46255",
  "enrichment-properties-lib": "static-1.16742",
  "ui-addon-draggable-compat": "static-2.4347",
  "commerce-billing-lib": "static-1.19355",
  "commerce-shared-components-lib": "static-1.18733",
  "commerce-tools-ui-lib": "static-1.10603",
  "crm-fe-perf": "static-1.22991",
  "event-emitter": "static-1.1036",
  "bend-plugin-pulse": "static-1.186",
  "fast-json-patch": "static-1.64",
  "calling-error-reporting": "static-1.31402",
  "shared-worker-versioning": "static-1.11123",
  "calling-usage-tracker": "static-1.6630",
  "voice-sms-access-library": "static-1.1327",
  "commerce-permissions": "static-1.863",
  "products-iframe-lib": "static-1.8167",
  "products-ui-components-shared-msw-handlers": "static-1.10559",
  "data-agent-kit": "static-1.332",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10260",
  "policy-lib": "static-1.6867",
  "react-tinymce": "static-1.55473",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10323",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54599",
  "tinymce-plugins": "static-1.57713",
  "tinymce-themes": "static-1.56569",
  "onboarding-data-sync-lib": "static-1.2110",
  "growth-onboarding-next-action-components": "static-1.2206",
  "user-context-client": "static-1.4678",
  "audio-components": "static-1.6047",
  "cropperjs": "static-1.10",
  "FileManagerImages": "static-1.36992",
  "html-to-image": "static-1.55",
  "urlinator": "static-1.4624",
  "video-components": "static-1.13566",
  "outpost": "static-1.4259",
  "growth-onboarding-feedback-components": "static-1.6667",
  "content-media-composition-data-lib": "static-1.12600",
  "content-media-compositions": "static-2.16607",
  "media-bridge-lib": "static-1.19073",
  "commerce-tours-lib": "static-1.6260",
  "growth-onboarding-reliability": "static-1.5168",
  "sales-checkout-service-client": "static-1.3689",
  "draft-convert": "static-2.74",
  "draft-extend": "static-3.76",
  "draft-js": "static-5.79",
  "draft-plugins": "static-2.21824",
  "sales-email-signature-service-client": "static-1.3936",
  "ts-utils-lib": "static-1.260",
  "crm-export-dialog": "static-1.6375",
  "crm-index-associations-lib": "static-1.6531",
  "crm-view-components": "static-1.537",
  "react-beautiful-dnd": "static-1.13",
  "customer-data-associations": "static-1.7417",
  "nudge-custom-function-registry": "static-1.2518",
  "nudge-renderer-utils": "static-1.2837",
  "whisper-core-api": "static-1.6817",
  "InboxConnectUtils": "static-4.15040",
  "emoji-regex": "static-1.7",
  "touchless-buying-components": "static-1.5729",
  "settings-content-modals": "static-1.46335",
  "crm_universal": "static-1.22156",
  "customer-data-email": "static-1.18184",
  "card-payment-highlight-lib": "static-1.37424",
  "card-subscription-highlight-lib": "static-1.39802",
  "commerce-contract-lib": "static-1.12502",
  "invoices-highlight-card-lib": "static-1.54996",
  "orders-highlight-card-lib": "static-1.21709",
  "products-highlight-card-lib": "static-1.18148",
  "quotes-highlight-card-lib": "static-1.72319",
  "crm-source-interpretation-lib": "static-1.5431",
  "utility-belt": "static-1.2620",
  "payments-enrollment-embed-lib": "static-1.23156",
  "stripe-embedded-components": "static-1.7658",
  "customer-data-rte": "static-1.33223",
  "cv-backend-services": "static-1.1555",
  "growth-onboarding-empty-states": "static-1.5893",
  "payments-post-enroll-local-storage-lib": "static-1.5195",
  "qrcode-generator": "static-1.70",
  "quotes-client-types": "static-1.38409",
  "trials-service-types": "static-1.3967",
  "calling-orchestration-schema": "static-1.36104",
  "sales-views-client-types": "static-1.4346",
  "hub-http-contrib": "static-1.3129",
  "interframe": "static-3.4847",
  "tinymce-data": "static-1.40684",
  "ui-addon-sales-email": "static-1.5298",
  "layout-dnd-components": "static-1.12607",
  "layout-dnd-utils": "static-1.11582",
  "ui-brand-identity-lib": "static-1.15587",
  "NamespacedHubStyle": "static-2.9124",
  "meetings-connect-utils-lib": "static-1.7692",
  "social-insights-client-types": "static-1.22298",
  "js-cookie": "static-1.18",
  "crm-index-visualization-core": "static-1.4248",
  "checkout-sdk": "static-3.23843",
  "checkout-service-types": "static-1.3866",
  "company-details-components": "static-1.6285",
  "payment-method-components": "static-1.6970",
  "pricing-pages-ui-components": "static-1.14556",
  "quote-checkout-service-types": "static-1.3553",
  "upgrade-catalog-service-types": "static-1.3608",
  "access-control-lib": "static-1.10522",
  "EmailComponents": "static-1.55009",
  "EmailData": "static-1.53686",
  "redux-less": "static-2.9571",
  "sequences-lib": "static-1.8192",
  "ui-gdpr-components": "static-1.10438",
  "products-ui-components": "static-1.40383",
  "accounting-integrations-ui-components": "static-1.7202",
  "invoices-ui-lib": "static-1.55012",
  "commerce-products-api": "static-1.2419",
  "invoices-iframe-lib": "static-1.57070",
  "quotes-modal-lib": "static-1.102997",
  "quotes-ui-lib": "static-1.81040",
  "stripe-connect-js": "static-1.70",
  "draft-content-plugins": "static-1.28494",
  "ContentData": "static-1.68681",
  "layout-data-lib": "static-1.9907",
  "hub-http-rxjs": "static-1.807",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "company-details-service-types": "static-1.4026",
  "billing-payments-client-types": "static-1.4079",
  "react-performance-metrics-lib": "static-1.644",
  "account-and-billing-fintech-outages": "static-3.18697",
  "pricing-pages-api": "static-1.14421",
  "ContentComponents": "static-2.71562",
  "marketing-contacts-lib": "static-1.10348",
  "marketing-email-service-types": "static-1.1968",
  "messaging-editing-lib": "static-1.46519",
  "messaging-usage-based-billing-components-lib": "static-1.1381",
  "automation-ui-source-apps": "static-1.19136",
  "automation-ui-types": "static-1.20054",
  "messaging-types-lib": "static-1.46256",
  "onboarding-settings-client": "static-1.4592",
  "sequences-client-types-lib": "static-1.8049",
  "commerce-tax-lib": "static-1.623",
  "price-books-api": "static-1.1156",
  "price-books-components": "static-1.1214",
  "property-description-translator": "static-1.3927",
  "ramp-editor": "static-1.342",
  "commerce-analytics-service-client": "static-1.3677",
  "totals-ui-components": "static-1.23837",
  "SalesContentIndexUI": "static-3.9369",
  "advanced-menus-core": "static-1.15267",
  "advanced-menus-lib": "static-1.12184",
  "ui-memberships-settings-lib": "static-1.34282",
  "segments-query-core": "static-1.1505",
  "eligibility-engine-service-types": "static-1.3248",
  "automation-ui-ubb": "static-1.5970",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7426",
  "data-token-views": "static-1.16537",
  "forms-utils-lib": "static-1.12743",
  "payments-embed-points-lib": "static-1.13209",
  "simple-menus-core": "static-1.15266",
  "simple-menus-lib": "static-1.16783",
  "videoconference-integration-components": "static-1.6941",
  "marketing-contacts-client": "static-1.7602",
  "automation-applications-service-types": "static-1.3591",
  "automation-platform-service-types": "static-1.2625",
  "ContentEditorUI": "static-2.77350",
  "short-messages-app-service-client": "static-1.4029",
  "web-interactives-components": "static-1.13907",
  "web-interactives-data": "static-1.13908",
  "messaging-shared-utils-lib": "static-1.830",
  "messaging-user-info-utils-lib": "static-1.1000",
  "email-portal-health-service-types": "static-1.1067",
  "line-items-api": "static-1.821",
  "commerce-totals-service-types": "static-1.3885",
  "FireAlarmUi": "static-1.4577",
  "sales-templates-service-types-lib": "static-1.4236",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.21990",
  "automation-ui-usage-tracking": "static-1.21453",
  "data-studio-ubb": "static-1.2973",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.27216",
  "collaboration-sidebar": "static-1.58083",
  "content-management-data-lib": "static-1.5541",
  "copilot-plugins": "static-1.11331",
  "cta-picker": "static-1.36634",
  "customer-agent-discovery-components-lib": "static-1.3331",
  "editor-components": "static-1.13350",
  "editor-iframe-lib": "static-1.8520",
  "error-messaging-js": "static-1.5280",
  "FormsCommonComponents": "static-1.86099",
  "pictos": "static-7.185",
  "react-transition-group": "static-2.66",
  "redux-request-state": "static-1.10734",
  "SharedLegalStrings": "static-1.1833",
  "smart-content-core": "static-1.42678",
  "smart-content-lib": "static-1.43331",
  "social-composer-lib": "static-1.59471",
  "structured-content-lib": "static-1.25421",
  "theme-previewer-lib": "static-1.53480",
  "tinymce-copilot": "static-1.16667",
  "xray-recommendation-lib": "static-1.8022",
  "automation-ui-routing": "static-1.21411",
  "sql-reporting-client-types": "static-1.5710",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.42377",
  "campaigns-utils-lib": "static-1.3277",
  "reporting-enablement": "static-1.23232",
  "chatspot-widget-iframe": "static-1.21706",
  "collaboration-sidebar-common": "static-1.2880",
  "forms-ai-lib": "static-1.4454",
  "codemirror-dlb": "static-1.58909",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6521",
  "report-customization-components": "static-1.13384",
  "data-quality-ui-library": "static-1.13259",
  "reporting-filters": "static-1.537",
  "reporting-insights-lib": "static-1.2004"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.12596",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.479",
  "data-fetching-client": "/data-fetching-client/static-1.9750",
  "foundations-components": "/foundations-components/static-1.8101",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1126",
  "foundations-theming": "/foundations-theming/static-1.4520",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.83",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8105",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10177",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyleTokens": "/HubStyleTokens/static-2.11562",
  "I18n": "/I18n/static-7.1634",
  "jasmine-runner": "/jasmine-runner/static-1.6549",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.12659",
  "quartz": "/quartz/static-1.7137",
  "react-dlb": "/react-dlb/static-1.80",
  "react-rhumb": "/react-rhumb/static-1.16770",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2945",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.9832",
  "settings-ui-lib": "/settings-ui-lib/static-1.12607",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7296",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11239",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9628",
  "unified-auth": "/unified-auth/static-1.594",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.876",
  "usage-tracker": "/usage-tracker/static-1.7436",
  "usage-tracker-core": "/usage-tracker-core/static-1.7286",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8182",
  "hub-http": "/hub-http/static-1.6309",
  "integrations-lib": "/integrations-lib/static-1.16444",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20069",
  "property-management-iframe": "/property-management-iframe/static-1.13458",
  "quartz-config": "/quartz-config/static-1.915",
  "quartz-core": "/quartz-core/static-1.6356",
  "quartz-routing": "/quartz-routing/static-1.567",
  "quick-fetch": "/quick-fetch/static-1.3983",
  "react": "/react/static-7.187",
  "rpc-client-utils": "/rpc-client-utils/static-1.4743",
  "ts-schema": "/ts-schema/static-1.4146",
  "ui-universal-auth": "/ui-universal-auth/static-1.9080",
  "UIComponents": "/UIComponents/static-3.8508",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.79",
  "metrics-js": "/metrics-js/static-1.9637",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3466",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3414",
  "quartz-webpack": "/quartz-webpack/static-1.3361",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.215",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4370",
  "floating-ui": "/floating-ui/static-1.57",
  "foundations-assets": "/foundations-assets/static-1.4957",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2236",
  "framer-motion": "/framer-motion/static-1.73",
  "hs-story-utils": "/hs-story-utils/static-1.9510",
  "react-aria": "/react-aria/static-1.67",
  "react-create-root-preference": "/react-create-root-preference/static-1.32",
  "react-select-plus": "/react-select-plus/static-1.106",
  "react-utils": "/react-utils/static-2.5409",
  "react-virtualized": "/react-virtualized/static-2.100",
  "StyleGuideUI": "/StyleGuideUI/static-3.488",
  "tanstack-table": "/tanstack-table/static-1.56",
  "trellis-assets": "/trellis-assets/static-1.2154",
  "ui-fonts": "/ui-fonts/static-1.824",
  "ui-images": "/ui-images/static-2.1174",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3003",
  "foundations-theming-base": "/foundations-theming-base/static-1.3505",
  "stylex": "/stylex/static-1.34",
  "HeadJS": "/HeadJS/static-2.766",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3216",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.153",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.222",
  "moment-timezone": "/moment-timezone/static-5.84",
  "jasmine": "/jasmine/static-4.4413",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9173",
  "ai-rendering-library": "/ai-rendering-library/static-1.10482",
  "chirp-fetch": "/chirp-fetch/static-1.1975",
  "connections-embed-lib": "/connections-embed-lib/static-1.1146",
  "copilot-toolkit": "/copilot-toolkit/static-1.11358",
  "feedback-loader": "/feedback-loader/static-1.29455",
  "laboratory-lib": "/laboratory-lib/static-3.7243",
  "marketplace-embed": "/marketplace-embed/static-1.22366",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.9964",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.20024",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.14239",
  "sanitize-text": "/sanitize-text/static-1.8232",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8791",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5850",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5122",
  "wootric-nps": "/wootric-nps/static-1.7048",
  "quartz-head": "/quartz-head/static-1.802",
  "web-vitals": "/web-vitals/static-1.7",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4740",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4242",
  "highcharts": "/highcharts/static-8.105",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2557",
  "reporting-data": "/reporting-data/static-1.67899",
  "cssUtils": "/cssUtils/static-1.816",
  "flux-actions": "/flux-actions/static-1.343",
  "HubStyle": "/HubStyle/static-2.11869",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10296",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10451",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7426",
  "icons": "/icons/static-2.651",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.18601",
  "storybook-react": "/storybook-react/static-1.34",
  "trellis-story-utils": "/trellis-story-utils/static-1.4600",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5584",
  "quartz-i18n": "/quartz-i18n/static-1.812",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.249",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.498",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.636",
  "slack-ui-library": "/slack-ui-library/static-1.10480",
  "fsm": "/fsm/static-1.3817",
  "customer-data-objects": "/customer-data-objects/static-1.7765",
  "property-translator": "/property-translator/static-1.5483",
  "hs-locale-management": "/hs-locale-management/static-1.147",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8014",
  "hs-promise-utils": "/hs-promise-utils/static-1.5679",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4965",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13859",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5694",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7869",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4564",
  "superstore": "/superstore/static-1.4848",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10309",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8024",
  "hub-http-janus": "/hub-http-janus/static-1.841",
  "hubspotter-http": "/hubspotter-http/static-1.4717",
  "immutable-less": "/immutable-less/static-1.4741",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.17476",
  "nav-meta": "/nav-meta/static-1.29876",
  "react-window": "/react-window/static-1.13",
  "self-service-api": "/self-service-api/static-1.10335",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18112",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3911",
  "property-management-common": "/property-management-common/static-1.5746",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9150",
  "dispatcher": "/dispatcher/static-1.138",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.540",
  "module-federation": "/module-federation/static-1.24",
  "quartz-auth": "/quartz-auth/static-1.812",
  "quartz-test": "/quartz-test/static-1.812",
  "quartz-tracking": "/quartz-tracking/static-1.516",
  "trellis-components": "/trellis-components/static-1.2173",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.153",
  "bender-build-tools": "/bender-build-tools/static-1.3278",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.21715",
  "ContentUtils": "/ContentUtils/static-1.68606",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13119",
  "sassPrefix": "/sassPrefix/static-1.157",
  "breeze-engine-core": "/breeze-engine-core/static-1.281",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.178",
  "avatar-components": "/avatar-components/static-1.2585",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40094",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13257",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.14595",
  "ExportDialog": "/ExportDialog/static-6.10470",
  "highlight.js": "/highlight.js/static-1.80",
  "markdown-it": "/markdown-it/static-1.6",
  "mermaid": "/mermaid/static-1.3",
  "reporting-action-components": "/reporting-action-components/static-1.41519",
  "reporting-snowflake": "/reporting-snowflake/static-1.56517",
  "reporting-ui-components": "/reporting-ui-components/static-2.65170",
  "reporting-visualizations": "/reporting-visualizations/static-1.59975",
  "ui-addon-teams": "/ui-addon-teams/static-1.21666",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.119",
  "magpie-lib": "/magpie-lib/static-1.5610",
  "navigation-components": "/navigation-components/static-1.18239",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1003",
  "magpie-types": "/magpie-types/static-1.5070",
  "simple-logging-lib": "/simple-logging-lib/static-1.3138",
  "ai-studio-lib": "/ai-studio-lib/static-1.11870",
  "app-governance-lib": "/app-governance-lib/static-1.1830",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10601",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8092",
  "ui-product-approvals": "/ui-product-approvals/static-1.28514",
  "ui-tool-access": "/ui-tool-access/static-1.10236",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.9331",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5853",
  "usage-tracker-public": "/usage-tracker-public/static-1.7247",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3652",
  "persist-promise": "/persist-promise/static-1.3787",
  "reference-resolvers": "/reference-resolvers/static-1.8262",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4012",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.424",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3105",
  "final-form": "/final-form/static-1.71",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.3028",
  "merchandise-lib": "/merchandise-lib/static-1.265",
  "atom": "/atom/static-1.5162",
  "purchase-motions-components": "/purchase-motions-components/static-1.6053",
  "salesImages": "/salesImages/static-1.526",
  "batch-promise": "/batch-promise/static-1.1630",
  "crm-component-utils": "/crm-component-utils/static-1.39317",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5976",
  "customer-data-properties": "/customer-data-properties/static-1.51883",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6977",
  "property-value-citations": "/property-value-citations/static-1.2497",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8186",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9148",
  "navigation-messaging": "/navigation-messaging/static-1.7566",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10175",
  "base-ui": "/base-ui/static-1.12",
  "react-day-picker": "/react-day-picker/static-1.4",
  "trellis-theming": "/trellis-theming/static-1.1027",
  "tanstack-virtual": "/tanstack-virtual/static-1.31",
  "cms-field-types": "/cms-field-types/static-1.4900",
  "content-icons-ui": "/content-icons-ui/static-1.2250",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9913",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7337",
  "crm-message-bus": "/crm-message-bus/static-1.43210",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22529",
  "events-data-lib": "/events-data-lib/static-1.318",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4809",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4071",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6882",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1070",
  "onboarding-tours": "/onboarding-tours/static-1.16762",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13929",
  "academy-common-lib": "/academy-common-lib/static-1.14055",
  "content-assistance-lib": "/content-assistance-lib/static-1.7889",
  "dashboard-lib": "/dashboard-lib/static-1.81872",
  "file-manager-components": "/file-manager-components/static-1.23841",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18657",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18473",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18465",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.19975",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8792",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4850",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11147",
  "user-context": "/user-context/static-1.5197",
  "growth-payments-core": "/growth-payments-core/static-1.25638",
  "reporting-plugins": "/reporting-plugins/static-1.10472",
  "reporting-reports": "/reporting-reports/static-1.67577",
  "idb-keyval": "/idb-keyval/static-1.45",
  "reactive-lib": "/reactive-lib/static-1.813",
  "nest": "/nest/static-1.319",
  "ably": "/ably/static-2.2",
  "codemirror": "/codemirror/static-5.96",
  "react-codemirror": "/react-codemirror/static-1.10715",
  "framework-listing-lib": "/framework-listing-lib/static-2.28940",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.30925",
  "apps-service-types": "/apps-service-types/static-1.3910",
  "oauth-service-types": "/oauth-service-types/static-1.4339",
  "react-dnd-compat": "/react-dnd-compat/static-1.4702",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.409",
  "onboarding-scopes": "/onboarding-scopes/static-1.6549",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4976",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7739",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15043",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3656",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9517",
  "redux-thunk": "/redux-thunk/static-2.43",
  "purchase-motions-api": "/purchase-motions-api/static-1.6056",
  "signup-constants": "/signup-constants/static-1.19044",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8143",
  "card-properties-lib": "/card-properties-lib/static-1.44459",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37379",
  "crm-actions": "/crm-actions/static-1.6427",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.43841",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9504",
  "customer-data-tracking": "/customer-data-tracking/static-1.6977",
  "hs-resources": "/hs-resources/static-1.262",
  "pulse": "/pulse/static-1.683",
  "calling-global-api": "/calling-global-api/static-1.64815",
  "calling-internal-common": "/calling-internal-common/static-1.31395",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66197",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58491",
  "commerce-products-lib": "/commerce-products-lib/static-1.9865",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3863",
  "crm-links": "/crm-links/static-1.6394",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4204",
  "external-options-client-types": "/external-options-client-types/static-1.4199",
  "google-libphonenumber": "/google-libphonenumber/static-1.39",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4287",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.721",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3757",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49051",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4032",
  "smart-property-lib": "/smart-property-lib/static-1.7624",
  "tiered-pricing": "/tiered-pricing/static-1.1408",
  "zustand": "/zustand/static-1.74",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11077",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.96",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1096",
  "growth-data-modal": "/growth-data-modal/static-1.5566",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3154",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2178",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.828",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7690",
  "academy-service-client": "/academy-service-client/static-1.3771",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.39340",
  "FileManagerLib": "/FileManagerLib/static-1.39481",
  "video-embed": "/video-embed/static-1.36056",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28807",
  "redux-actions": "/redux-actions/static-3.7",
  "video-components-external": "/video-components-external/static-1.11564",
  "video-data-lib": "/video-data-lib/static-1.35222",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8552",
  "payment-link-components": "/payment-link-components/static-1.23746",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9975",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24562",
  "viral-links-lib": "/viral-links-lib/static-1.7156",
  "data-token-picker": "/data-token-picker/static-1.16556",
  "react-flip-move": "/react-flip-move/static-1.72",
  "nested-table": "/nested-table/static-1.313",
  "timezone-utils": "/timezone-utils/static-2.5331",
  "seat-types-lib": "/seat-types-lib/static-1.219",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17775",
  "ui-addon-opt": "/ui-addon-opt/static-4.8448",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.9348",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "customer-data-views-management": "/customer-data-views-management/static-1.25623",
  "framework-data-table": "/framework-data-table/static-2.12109",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.6951",
  "nudge-client-utils": "/nudge-client-utils/static-1.2761",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1184",
  "switchboard-lib": "/switchboard-lib/static-1.310",
  "app-users-service-client": "/app-users-service-client/static-1.5694",
  "app-users-service-types": "/app-users-service-types/static-1.5102",
  "mini-checkout-client": "/mini-checkout-client/static-1.27000",
  "onboarding-utils": "/onboarding-utils/static-1.5448",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2058",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.28792",
  "edison-service-client-types": "/edison-service-client-types/static-1.477",
  "crm_data": "/crm_data/static-4.92250",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46255",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.16742",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4347",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.19355",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18733",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10603",
  "crm-fe-perf": "/crm-fe-perf/static-1.22991",
  "event-emitter": "/event-emitter/static-1.1036",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.186",
  "fast-json-patch": "/fast-json-patch/static-1.64",
  "calling-error-reporting": "/calling-error-reporting/static-1.31402",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11123",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6630",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1327",
  "commerce-permissions": "/commerce-permissions/static-1.863",
  "products-iframe-lib": "/products-iframe-lib/static-1.8167",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10559",
  "data-agent-kit": "/data-agent-kit/static-1.332",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10260",
  "policy-lib": "/policy-lib/static-1.6867",
  "react-tinymce": "/react-tinymce/static-1.55473",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10323",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54599",
  "tinymce-plugins": "/tinymce-plugins/static-1.57713",
  "tinymce-themes": "/tinymce-themes/static-1.56569",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2110",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2206",
  "user-context-client": "/user-context-client/static-1.4678",
  "audio-components": "/audio-components/static-1.6047",
  "cropperjs": "/cropperjs/static-1.10",
  "FileManagerImages": "/FileManagerImages/static-1.36992",
  "html-to-image": "/html-to-image/static-1.55",
  "urlinator": "/urlinator/static-1.4624",
  "video-components": "/video-components/static-1.13566",
  "outpost": "/outpost/static-1.4259",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6667",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12600",
  "content-media-compositions": "/content-media-compositions/static-2.16607",
  "media-bridge-lib": "/media-bridge-lib/static-1.19073",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6260",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5168",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3689",
  "draft-convert": "/draft-convert/static-2.74",
  "draft-extend": "/draft-extend/static-3.76",
  "draft-js": "/draft-js/static-5.79",
  "draft-plugins": "/draft-plugins/static-2.21824",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3936",
  "ts-utils-lib": "/ts-utils-lib/static-1.260",
  "crm-export-dialog": "/crm-export-dialog/static-1.6375",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6531",
  "crm-view-components": "/crm-view-components/static-1.537",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
  "customer-data-associations": "/customer-data-associations/static-1.7417",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2518",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2837",
  "whisper-core-api": "/whisper-core-api/static-1.6817",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15040",
  "emoji-regex": "/emoji-regex/static-1.7",
  "touchless-buying-components": "/touchless-buying-components/static-1.5729",
  "settings-content-modals": "/settings-content-modals/static-1.46335",
  "crm_universal": "/crm_universal/static-1.22156",
  "customer-data-email": "/customer-data-email/static-1.18184",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37424",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39802",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.12502",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54996",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.21709",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.18148",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72319",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5431",
  "utility-belt": "/utility-belt/static-1.2620",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.23156",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7658",
  "customer-data-rte": "/customer-data-rte/static-1.33223",
  "cv-backend-services": "/cv-backend-services/static-1.1555",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5893",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5195",
  "qrcode-generator": "/qrcode-generator/static-1.70",
  "quotes-client-types": "/quotes-client-types/static-1.38409",
  "trials-service-types": "/trials-service-types/static-1.3967",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36104",
  "sales-views-client-types": "/sales-views-client-types/static-1.4346",
  "hub-http-contrib": "/hub-http-contrib/static-1.3129",
  "interframe": "/interframe/static-3.4847",
  "tinymce-data": "/tinymce-data/static-1.40684",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5298",
  "layout-dnd-components": "/layout-dnd-components/static-1.12607",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11582",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15587",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9124",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7692",
  "social-insights-client-types": "/social-insights-client-types/static-1.22298",
  "js-cookie": "/js-cookie/static-1.18",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4248",
  "checkout-sdk": "/checkout-sdk/static-3.23843",
  "checkout-service-types": "/checkout-service-types/static-1.3866",
  "company-details-components": "/company-details-components/static-1.6285",
  "payment-method-components": "/payment-method-components/static-1.6970",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.14556",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3553",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3608",
  "access-control-lib": "/access-control-lib/static-1.10522",
  "EmailComponents": "/EmailComponents/static-1.55009",
  "EmailData": "/EmailData/static-1.53686",
  "redux-less": "/redux-less/static-2.9571",
  "sequences-lib": "/sequences-lib/static-1.8192",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10438",
  "products-ui-components": "/products-ui-components/static-1.40383",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7202",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.55012",
  "commerce-products-api": "/commerce-products-api/static-1.2419",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.57070",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.102997",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.81040",
  "stripe-connect-js": "/stripe-connect-js/static-1.70",
  "draft-content-plugins": "/draft-content-plugins/static-1.28494",
  "ContentData": "/ContentData/static-1.68681",
  "layout-data-lib": "/layout-data-lib/static-1.9907",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.807",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "company-details-service-types": "/company-details-service-types/static-1.4026",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4079",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.644",
  "account-and-billing-fintech-outages": "/account-and-billing-fintech-outages/static-3.18697",
  "pricing-pages-api": "/pricing-pages-api/static-1.14421",
  "ContentComponents": "/ContentComponents/static-2.71562",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.10348",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.1968",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.46519",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1381",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.19136",
  "automation-ui-types": "/automation-ui-types/static-1.20054",
  "messaging-types-lib": "/messaging-types-lib/static-1.46256",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4592",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8049",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.623",
  "price-books-api": "/price-books-api/static-1.1156",
  "price-books-components": "/price-books-components/static-1.1214",
  "property-description-translator": "/property-description-translator/static-1.3927",
  "ramp-editor": "/ramp-editor/static-1.342",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3677",
  "totals-ui-components": "/totals-ui-components/static-1.23837",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9369",
  "advanced-menus-core": "/advanced-menus-core/static-1.15267",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12184",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34282",
  "segments-query-core": "/segments-query-core/static-1.1505",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3248",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.5970",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7426",
  "data-token-views": "/data-token-views/static-1.16537",
  "forms-utils-lib": "/forms-utils-lib/static-1.12743",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13209",
  "simple-menus-core": "/simple-menus-core/static-1.15266",
  "simple-menus-lib": "/simple-menus-lib/static-1.16783",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.6941",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.7602",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3591",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2625",
  "ContentEditorUI": "/ContentEditorUI/static-2.77350",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4029",
  "web-interactives-components": "/web-interactives-components/static-1.13907",
  "web-interactives-data": "/web-interactives-data/static-1.13908",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.830",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.1000",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1067",
  "line-items-api": "/line-items-api/static-1.821",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3885",
  "FireAlarmUi": "/FireAlarmUi/static-1.4577",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4236",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.21990",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.21453",
  "data-studio-ubb": "/data-studio-ubb/static-1.2973",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.27216",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.58083",
  "content-management-data-lib": "/content-management-data-lib/static-1.5541",
  "copilot-plugins": "/copilot-plugins/static-1.11331",
  "cta-picker": "/cta-picker/static-1.36634",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.3331",
  "editor-components": "/editor-components/static-1.13350",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8520",
  "error-messaging-js": "/error-messaging-js/static-1.5280",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86099",
  "pictos": "/pictos/static-7.185",
  "react-transition-group": "/react-transition-group/static-2.66",
  "redux-request-state": "/redux-request-state/static-1.10734",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1833",
  "smart-content-core": "/smart-content-core/static-1.42678",
  "smart-content-lib": "/smart-content-lib/static-1.43331",
  "social-composer-lib": "/social-composer-lib/static-1.59471",
  "structured-content-lib": "/structured-content-lib/static-1.25421",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53480",
  "tinymce-copilot": "/tinymce-copilot/static-1.16667",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.8022",
  "automation-ui-routing": "/automation-ui-routing/static-1.21411",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5710",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.42377",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3277",
  "reporting-enablement": "/reporting-enablement/static-1.23232",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.21706",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.2880",
  "forms-ai-lib": "/forms-ai-lib/static-1.4454",
  "codemirror-dlb": "/codemirror-dlb/static-1.58909",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6521",
  "report-customization-components": "/report-customization-components/static-1.13384",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.13259",
  "reporting-filters": "/reporting-filters/static-1.537",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.2004"
}
};
